import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import queryClient from 'state/queryClient';
import { QueryClientProvider } from '@tanstack/react-query';
import ServiceWorkerWrapper from './ServiceWorkerWrapper';
import './assets/scss/index.scss';
// import * as Sentry from '@sentry/react';
// import config from 'util/config-loader';
import OfflineModel from 'OfflineModel';

// Sentry.init({
//   integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
//   ...config.SENTRY_CONFIG,
// });

ReactDOM.render(
  <>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
    <ServiceWorkerWrapper />
    {<OfflineModel/>}
  </>,
  document.getElementById('root')
);
